import React, {Component} from 'react';
import {Button, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {Column} from '../../Form/serializers/column';
import {ColumnsSearch} from './ColumnSearch';
import {Search} from '../stores/Search';
import {Form} from '../../Form/stores/Form';

interface Props {
    selectedSearch: Search;
    currentForm: Form;
    autoFocus?: boolean;
    hideRecommendedSearch: () => void;
}

@observer
export class AddField extends Component<Props, {showDropdown}> {
    private lastInteraction: 'mouse' | 'keyboard' | null = null;
    constructor(props) {
        super(props);
        this.state = {showDropdown: false};
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleMouse);
        document.addEventListener('touchstart', this.handleMouse);
        document.addEventListener('keydown', this.handleKeyboard);
        document.addEventListener('focusin', this.handleFocusChange);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleMouse);
        document.removeEventListener('touchstart', this.handleMouse);
        document.removeEventListener('keydown', this.handleKeyboard);
        document.removeEventListener('focusin', this.handleFocusChange);
    }

    addFilter = item => {
        const {selectedSearch} = this.props;
        selectedSearch.addFilter(item);
        this.setState({showDropdown: false});
    };

    showDropdown = () => {
        this.setState({showDropdown: true});
    };

    showButton = () => {
        const {selectedSearch} = this.props;
        if (selectedSearch.filters.size > 0 && this.state.showDropdown) {
            this.setState({showDropdown: false});
        }
    };
    isElementContainsActive(element: HTMLElement | null): boolean {
        if (!element) {
            return false;
        }
        const active = document.activeElement;
        if (!active) {
            return false;
        }
        return element.contains(active);
    }

    handleFocusChange = () => {
        const columnSearch = document.getElementById('column-search');
        if (this.isElementContainsActive(columnSearch) && this.lastInteraction === 'keyboard') {
            this.props.hideRecommendedSearch();
        }
        this.lastInteraction = null;
    };

    handleMouse = () => {
        this.lastInteraction = 'mouse';
    };

    handleKeyboard = () => {
        this.lastInteraction = 'keyboard';
    };

    render() {
        const {selectedSearch, currentForm, autoFocus = true, hideRecommendedSearch} = this.props;
        const isEmptySearch = selectedSearch.filters.size === 0;
        return isEmptySearch || this.state.showDropdown ? (
            <div tabIndex={-1} id="column-search" onClick={hideRecommendedSearch}>
                <ColumnsSearch
                    openOnFocus
                    className="select-field"
                    dropdown
                    inputProps={{
                        autoFocus: autoFocus,
                        size: 'large',
                        width: 'fullWidth',
                        placeholder: getLocalizedText(texts.selectFieldPlaceholder)
                    }}
                    keyToSearch="title"
                    closeOnSelect={false}
                    options={
                        currentForm.isRecon
                            ? currentForm.visibleColumns.filter(
                                  c => c.name.startsWith('FRST_') || c.name.startsWith('SCND_')
                              )
                            : currentForm.visibleColumns
                    }
                    handleClickOutside={this.showButton}
                    isOptionDisabled={(option: Column) => {
                        return selectedSearch.filteredColumns.indexOf(option.field) > -1;
                    }}
                    onSelect={this.addFilter}
                    listProps={{autoHeightMax: isEmptySearch ? 46 * 10 : 46 * 6}}
                />
            </div>
        ) : (
            <Button
                skin="secondary"
                icon={PriorityIcon.add}
                size="large"
                width="fullWidth"
                componentClasses="add-field-button"
                onClick={this.showDropdown}
            >
                {getLocalizedText(texts.newField)}
            </Button>
        );
    }
}
